import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalSeparator',
    standalone: false
})
export class DecimalSeparatorPipe implements PipeTransform {
    transform(value: unknown, direction: 'toDot' | 'toComma' = 'toComma'): string {
        const text = String(value ?? '').trim();

        if (!text) {
            return '';
        }

        if (direction === 'toDot') {
            if (text.includes(',')) {
                return text.replace(/\./g, '').replace(',', '.');
            }

            return text.match(/^\d{1,3}(\.\d{3})+$/)
                ? text.replace(/\./g, '')
                : text;
        }

        return text.replace(/\./g, ',');
    }
}
